import { Link } from "react-router-dom";

const HeroSection = () => (
  <section
    className="wd-negative-gap elementor-section elementor-top-section elementor-element elementor-element-26d48e92 elementor-section-height-min-height elementor-section-content-middle wd-section-stretch elementor-section-boxed elementor-section-height-default elementor-section-items-middle"
    data-id="26d48e92" data-element_type="section" data-settings='{"background_background":"classic"}'
    // Assuming background image is handled by CSS from Elementor sheets or needs to be added via style prop
  >
    <div className="elementor-background-overlay"></div>
    <div className="elementor-container elementor-column-gap-default">
      <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-c5d9488" data-id="c5d9488" data-element_type="column">
        <div className="elementor-widget-wrap elementor-element-populated">
          <div className="elementor-element elementor-element-23771e7f wd-width-100 elementor-widget elementor-widget-wd_title" data-id="23771e7f" data-element_type="widget" data-widget_type="wd_title.default">
            <div className="elementor-widget-container">
              <div className="title-wrapper wd-set-mb reset-last-child wd-title-color-white wd-title-style-default wd-title-size-default text-center">
                <div className="liner-continer">
                  <h4 className="woodmart-title-container title wd-fontsize-l">
                    Empowering Learners to Think Freely and Act Boldly <strong>imw-edu</strong>
                  </h4>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="elementor-element elementor-element-5d7488a7 elementor-widget__width-auto elementor-widget elementor-widget-wd_button" data-id="5d7488a7" data-element_type="widget" data-widget_type="wd_button.default">
            <div className="elementor-widget-container">
              <div className="wd-button-wrapper text-center">
                <Link className="btn btn-style-default btn-shape-round btn-size-default btn-color-primary btn-icon-pos-right" to="/about">
                  <span className="wd-btn-text">Read More</span>
                </Link>
              </div>
            </div>
          </div> */}
          {/* <div className="elementor-element elementor-element-490967b6 elementor-widget__width-auto elementor-widget elementor-widget-wd_button" data-id="490967b6" data-element_type="widget" data-widget_type="wd_button.default">
            <div className="elementor-widget-container">
              <div className="wd-button-wrapper text-center">
                <Link className="btn btn-style-bordered btn-shape-round btn-size-default btn-color-white btn-icon-pos-right" to="/about">
                  <span className="wd-btn-text">View More</span>
                </Link>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;